import React from 'react'
import Name from '@/components/Name'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import Resx from '@/components/Resx'

const ReportSubmissionGroupNoteList = (props) => {
  if ((props.notes || []).length === 0) {
    return <Resx name='Reporting.NoNotes' />
  }
  return (
    <div className='ReportSubmissionGroupNotes'>
      {props.notes.map(note => <div className='note' key={note.id}>
        <div><Name data={note} /> - {formatDate(note.creationTime, defaultDateTimeFormat)}</div>
        <div className='note-text' dangerouslySetInnerHTML={{ __html: note.text }} />
        <hr />
      </div>)}
    </div>
  )
}

export default ReportSubmissionGroupNoteList



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/notes/list.js